import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { authSlice } from './globalSlices/authSlice';
import { useDispatch, useSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
// import { contactSlice } from './globalSlices/contactSlice';
// import { companySlice } from './globalSlices/companySlice';
// import { priceListSlice } from './globalSlices/priceListSlice';
import { invoiceSlice } from './globalSlices/invoiceSlice';
import { buyersSlice } from './globalSlices/buyersSlice';
import { suppliersSlice } from './globalSlices/suppliersSlice';
import { paymentsSlice } from './globalSlices/paymentsSlice';
import { salesReceiptsSlice } from './globalSlices/salesReceiptsSlice';
import { lienTemplatesSlice } from './globalSlices/lienTemplatesSlice';
import { subSuppliersSlice } from './globalSlices/subSuppliersSlice';
import { jobsSlice } from './globalSlices/jobsSlice';
import { liensSlice } from './globalSlices/liensSlice';
import { genericSlice } from './globalSlices/genericSlice';
import { supplierJobsSlice } from './globalSlices/supplierJobsSlice';
import { supplierBuyersSlice } from './globalSlices/supplierBuyersSlice';
import { noticeTemplatesSlice } from './globalSlices/noticeTemplatesSlice';
import { preliminaryNoticesSlice } from './globalSlices/preliminaryNoticesSlice';
import { manualUploadSlice } from './globalSlices/manualUploadSlice';
import { APP_ENVIRONMENT } from '../utils/constants';
import { inforDistSXSlice } from './globalSlices/inforDistSX';
import { distributionOneSlice } from './globalSlices/distributionOneSlice';
import { sage100Slice } from './globalSlices/sage100Slice';
import { p21Slice } from './globalSlices/p21Slice';
import { supplierReleasesSlice } from './globalSlices/supplierReleasesSlice';
import { requestJobInformationSlice } from './globalSlices/requestJobInformationSlice';
import { paymentRequestsSlice } from './globalSlices/paymentRequestsSlice';
import { reportsSlice } from './globalSlices/reportsSlice';
import { filedLiensSlice } from './globalSlices/filedLiensSlice';
import { filedLienTemplatesSlice } from './globalSlices/filedLienTemplatesSlice';
import { creditApplicationTemplatesSlice } from './globalSlices/creditApplicationTemplatesSlice';
import { creditApplicationsSlice } from './globalSlices/creditApplicationsSlice';
import { creditApplicationsMonitorSlice } from './globalSlices/creditApplicationsMonitorSlice';
import { disputesSlice } from './globalSlices/disputesSlice';
import { userLoginAttemptsSlice } from './globalSlices/userLoginAttemptsSlice';
import { syncHistorySlice } from './globalSlices/syncHistorySlice';
import { tradeReferencesSlice } from './globalSlices/tradeReferenceSlice';
import { collectionActivitySlice } from './globalSlices/collectionActivitySlice';
import { promiseToPaySlice } from './globalSlices/promiseToPaySlice';
import { customerCollectionViewsSlice } from './globalSlices/customerCollectionViewsSlice';
import { paymentPlanSlice } from './globalSlices/paymentPlanSlice';
import { collectionSequenceSlice } from './globalSlices/collectionSequenceSlice';
import { collectionTriggerSlice } from './globalSlices/collectionTriggerSlice';
import { disputeRoutingRuleSlice } from './globalSlices/disputeRoutingRuleSlice';
import { salesRepSlice } from './globalSlices/supplierAdditionalDetailsSlice';
import { supplierIntegrationDetailsSlice } from './globalSlices/supplierIntegrationDetailsSlice';
import { taxExemptionTeamSlice } from './globalSlices/taxExemptionTeamSlice';
import { supplierBranchesSlice } from './globalSlices/supplierBranchesSlice';
import { invoiceNoticeLogSlice } from './globalSlices/invoiceNoticeLogSlice';
import { creditSafeSlice } from './globalSlices/creditSafeSlice';
import previewReducer from './globalSlices/previewSlice';
import cashApplicationReducer from './globalSlices/cashApplicationSlice';
import { listenerMiddleware } from './listeners/supplierChangeListener';

// const reducers = combineReducers({});

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    // contact: contactSlice.reducer,
    // company: companySlice.reducer,
    // priceList: priceListSlice.reducer,
    invoice: invoiceSlice.reducer,
    buyers: buyersSlice.reducer,
    supplier: suppliersSlice.reducer,
    payments: paymentsSlice.reducer,
    salesReceipts: salesReceiptsSlice.reducer,
    lienTemplates: lienTemplatesSlice.reducer,
    subSuppliers: subSuppliersSlice.reducer,
    jobs: jobsSlice.reducer,
    liens: liensSlice.reducer,
    generic: genericSlice.reducer,
    supplierJobs: supplierJobsSlice.reducer,
    supplierBuyers: supplierBuyersSlice.reducer,
    noticeTemplates: noticeTemplatesSlice.reducer,
    preliminaryNotices: preliminaryNoticesSlice.reducer,
    manualUpload: manualUploadSlice.reducer,
    inforDistSX: inforDistSXSlice.reducer,
    distributionOne: distributionOneSlice.reducer,
    sage100: sage100Slice.reducer,
    p21: p21Slice.reducer,
    supplierReleases: supplierReleasesSlice.reducer,
    requestJobInformation: requestJobInformationSlice.reducer,
    paymentRequests: paymentRequestsSlice.reducer,
    reports: reportsSlice.reducer,
    filedLiens: filedLiensSlice.reducer,
    filedLienTemplates: filedLienTemplatesSlice.reducer,
    creditApplicationTemplates: creditApplicationTemplatesSlice.reducer,
    creditApplications: creditApplicationsSlice.reducer,
    creditApplicationsMonitor: creditApplicationsMonitorSlice.reducer,
    disputes: disputesSlice.reducer,
    userLoginAttempts: userLoginAttemptsSlice.reducer,
    syncHistory: syncHistorySlice.reducer,
    tradeReferences: tradeReferencesSlice.reducer,
    collectionActivities: collectionActivitySlice.reducer,
    promiseToPays: promiseToPaySlice.reducer,
    customerCollectionViews: customerCollectionViewsSlice.reducer,
    paymentPlans: paymentPlanSlice.reducer,
    collectionSequences: collectionSequenceSlice.reducer,
    collectionTriggers: collectionTriggerSlice.reducer,
    disputeRoutingRules: disputeRoutingRuleSlice.reducer,
    salesReps: salesRepSlice.reducer,
    supplierIntegrationDetails: supplierIntegrationDetailsSlice.reducer,
    taxExemptionTeam: taxExemptionTeamSlice.reducer,
    supplierBranches: supplierBranchesSlice.reducer,
    invoiceNoticeLogs: invoiceNoticeLogSlice.reducer,
    preview: previewReducer,
    creditSafe: creditSafeSlice.reducer,
    cashApplication: cashApplicationReducer,
  },
  devTools: APP_ENVIRONMENT !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).prepend(listenerMiddleware.middleware),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => typeof store.dispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<ReturnType<typeof store.getState>> = useSelector;
